module.exports = __webpack_public_path__ + "img/welcome_banner.5468c1d7.png";